import { Button, Col, Input, Row } from 'reactstrap';
import { AvField } from 'availity-reactstrap-validation';

import SettingsField from '../settings-field';

const MicrosoftEntraFields = ({
    t,
    isFetching,
    defaultSettings,
    oauthEntraConfigured,
    redirectUri,
    onCopyRedirectUri,
    onOpenSetupGuide,
}) => {
    const secretRequired = !oauthEntraConfigured;

    return (
        <>
            <div className="d-flex justify-content-between align-items-start flex-wrap mb-3">
                <div className="me-3">
                    <h6 className="font-size-14 fw-semibold mb-1">
                        {t('Microsoft connection')}
                    </h6>
                    <p className="text-muted font-size-12 mb-0">
                        {t('Connect your Microsoft mailbox securely using Microsoft Entra.')}
                    </p>
                </div>
                <Button
                    color="link"
                    type="button"
                    className="p-0 fw-semibold text-decoration-none text-nowrap"
                    onClick={onOpenSetupGuide}
                >
                    {t('View IT setup guide')}
                    <i className="ri-arrow-right-line align-middle ms-1" />
                </Button>
            </div>

            <Row>
                <Col sm="12" md="6" className="mb-3">
                    <SettingsField
                        id="oauthTenantId"
                        label={t('Microsoft tenant ID')}
                        required
                        isFetching={isFetching}
                        info={t('Identifies your company in Microsoft Entra (Azure AD), not a person and not this mailbox password.')}
                    >
                        <AvField
                            id="oauthTenantId"
                            name="oauthTenantId"
                            type="text"
                            className="form-control"
                            placeholder="xxxxxxxx-xxxx-xxxx-xxxx-xxxxxxxxxxxx"
                            validate={{
                                required: {
                                    value: true,
                                    errorMessage: t('This field cannot be blank'),
                                },
                            }}
                            value={defaultSettings?.oauthTenantId || ''}
                        />
                    </SettingsField>
                </Col>

                <Col sm="12" md="6" className="mb-3">
                    <SettingsField
                        id="oauthClientId"
                        label={t('Application (client) ID')}
                        required
                        isFetching={isFetching}
                        info={t('ID of your organization’s Entra App Registration. This is not the Tenant ID.')}
                    >
                        <AvField
                            id="oauthClientId"
                            name="oauthClientId"
                            type="text"
                            className="form-control"
                            placeholder="xxxxxxxx-xxxx-xxxx-xxxx-xxxxxxxxxxxx"
                            validate={{
                                required: {
                                    value: true,
                                    errorMessage: t('This field cannot be blank'),
                                },
                            }}
                            value={defaultSettings?.oauthClientId || ''}
                        />
                    </SettingsField>
                </Col>

                <Col sm="12" md="6" className="mb-3">
                    <SettingsField
                        id="oauthClientSecret"
                        label={t('Client secret value')}
                        required={secretRequired}
                        isFetching={isFetching}
                        info={t('Copy the secret Value immediately after creating it. Do not paste Secret ID (the UUID). Leave blank on edit to keep the saved secret.')}
                        hint={oauthEntraConfigured
                            ? t('Secret saved. Enter a new value only to replace it.')
                            : undefined}
                    >
                        <AvField
                            id="oauthClientSecret"
                            name="oauthClientSecret"
                            type="password"
                            className="form-control"
                            autoComplete="new-password"
                            placeholder={oauthEntraConfigured ? '••••••••••••' : ''}
                            validate={{
                                required: {
                                    value: secretRequired,
                                    errorMessage: t('This field cannot be blank'),
                                },
                            }}
                        />
                    </SettingsField>
                </Col>

                <Col sm="12" md="6" className="mb-3">
                    <SettingsField
                        id="oauthRedirectUri"
                        label={t('Redirect URI')}
                        isFetching={isFetching}
                        info={t('Copy this into Entra. SIP owns this URL; the org does not invent it.')}
                    >
                        <div className="d-flex align-items-center">
                            <Input
                                id="oauthRedirectUri"
                                type="text"
                                className="form-control"
                                value={redirectUri}
                                readOnly
                            />
                            <Button
                                type="button"
                                color="light"
                                className="ms-2 text-nowrap"
                                onClick={onCopyRedirectUri}
                            >
                                <i className="ri-file-copy-line align-middle me-1" />
                                {t('Copy')}
                            </Button>
                        </div>
                    </SettingsField>
                </Col>
            </Row>
        </>
    );
};

export default MicrosoftEntraFields;
